export enum EAddTypeId {
	task = 'add-task',
	milestone = 'add-milestone',
}
